import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  STAFF_FEATURE_KEY,
  StaffState,
  staffAdapter
} from './staff.reducer';

// Lookup the 'Staff' feature state managed by NgRx
export const getStaffState = createFeatureSelector<StaffState>(STAFF_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = staffAdapter.getSelectors();

export const getStaffLoaded = createSelector(
  getStaffState,
  (state: StaffState) => state.staffLoaded
);

export const getStaffLoadError = createSelector(
  getStaffState,
  (state: StaffState) => state.staffLoadError
);

export const getAddStaffSuccess = createSelector(
  getStaffState,
  (state: StaffState) => state.addStaffSuccess
);


export const getAddStaffError = createSelector(
  getStaffState,
  (state: StaffState) => state.addStaffError
);


export const getUpdateStaffSuccess = createSelector(
  getStaffState,
  (state: StaffState) => state.updateStaffSuccess
);


export const getUpdateStaffError = createSelector(
  getStaffState,
  (state: StaffState) => state.updateStaffError
);


export const getDeleteStaffSuccess = createSelector(
  getStaffState,
  (state: StaffState) => state.deleteStaffLoaded
);


export const getDeleteStaffError = createSelector(
  getStaffState,
  (state: StaffState) => state.deleteStaffError
);


export const getQueryStaffError = createSelector(
  getStaffState,
  (state: StaffState) => state.queryStaffLoadError
);

// All Organization Users (Contactpersons of Clients with access and all Staff)
export const getAllOrganizationUsers = createSelector(getStaffState, (state: StaffState) =>
  selectAll(state)
);


export const getAllStaff = createSelector(getAllOrganizationUsers,
  (staff) =>
    staff.filter(item => item.type === 'staff')
);


export const getAllClientUsers = createSelector(getAllOrganizationUsers,
  (staff) =>
    staff.filter(item => item.type === 'client')
);


export const getOrganizationUserEntities = createSelector(
  getStaffState,
  (state: StaffState) => selectEntities(state)
);



export const getSelectedId = createSelector(
  getStaffState,
  (state: StaffState) => state.selectStaffId
);

export const getSelected = createSelector(
  getOrganizationUserEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getStaffById = createSelector(getAllStaff,
  (staff, props) =>
    staff.find(item => item.id === props.id)
);


export const getActiveStaff = createSelector(getAllOrganizationUsers,
  (staff) =>
    staff.filter(item => item.status === 'active')
);


export const getActiveAndInvitedStaff = createSelector(getAllOrganizationUsers,
  (staff) =>
    staff.filter(item => {
      if (item.status === 'active') {
        return item;
      }
      if (item.status === 'invited') {
        return item;
      }
    })
);


export const getAdminAndMemberStaff = createSelector(getAllStaff,
  (staff) =>
    staff
      .filter(item => {
        if (item.role === 'manager') {
          return item;
        }
        if (item.role === 'admin') {
          return item;
        }
      })
);


export const getInvitedStaff = createSelector(getAllStaff,
  (staff) =>
    staff.filter(item => item.status === 'invited')
);


export const getInActiveStaff = createSelector(getAllStaff,
  (staff) =>
    staff.filter(item => item.status === 'inactive')
);






